/* ════════════════════════════════════════════════════════════
   4N6 / SPLASH — 2-second redacted-box loader
   Small red REDACTED block in center, dark bars stretching from
   each side toward it, text inside the block shuffles, then
   the whole thing dismisses at t=2000ms.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  const TOTAL_MS  = 2000;        // total splash duration
  const SHUFFLE_MS = 110;        // text shuffle interval
  const SHUFFLE_END = 1700;      // stop shuffling at t=1700ms (last 300ms = locked)
  const FINAL_TEXT = 'ACCESS GRANTED';

  const SHUFFLE_POOL = [
    'INITIALIZING',
    'DECRYPTING',
    'MOUNTING /EVIDENCE',
    'CONNECTING',
    'VERIFYING',
    '0x7F2A9C4B',
    'HANDSHAKE',
    'SECURE CHANNEL',
    'NODE IN-DEL-04',
    'CASE REGISTRY',
    'ACCESS GRANTED'
  ];

  // ── Gate: only show on direct/initial arrival, once per session
  const params   = new URLSearchParams(window.location.search);
  const force    = params.get('splash');
  const SEEN     = '4n6_splash_seen';
  const referrer = document.referrer;
  const isInternal = referrer && referrer.includes(window.location.hostname);
  let seen = false;
  try { seen = sessionStorage.getItem(SEEN) === '1'; } catch (e) {}

  if (force === '0' || (seen && force !== '1') || isInternal) {
    const ex = document.getElementById('splash');
    if (ex) ex.remove();
    return;
  }
  try { sessionStorage.setItem(SEEN, '1'); } catch (e) {}

  // ── Build markup
  let splash = document.getElementById('splash');
  if (!splash) {
    splash = document.createElement('div');
    splash.id = 'splash';
    document.body.appendChild(splash);
  }
  splash.innerHTML =
    '<div class="splash-core">' +
      '<span class="splash-bar splash-bar--left"></span>' +
      '<div class="splash-box">' +
        '<span class="splash-box-text" data-shuffle>' + SHUFFLE_POOL[0] + '</span>' +
      '</div>' +
      '<span class="splash-bar splash-bar--right"></span>' +
    '</div>';

  // Lock scroll while splash is up
  const prevOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';

  let dismissed = false;
  function dismiss() {
    if (dismissed) return;
    dismissed = true;
    clearInterval(shuffleTimer);
    clearTimeout(lockTimer);
    clearTimeout(dismissTimer);
    document.body.style.overflow = prevOverflow;
    splash.classList.add('dismiss');
    setTimeout(function () { if (splash && splash.parentNode) splash.remove(); }, 380);
  }

  // Click or any key dismisses early (skip)
  document.addEventListener('keydown', dismiss, { once: true });
  splash.addEventListener('click',   dismiss, { once: true });

  // ── Trigger bar animation (next frame so transition fires)
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { splash.classList.add('splash-armed'); });
  });

  // ── Shuffle the text rapidly
  const textEl = splash.querySelector('[data-shuffle]');
  let i = 0;
  const shuffleTimer = setInterval(function () {
    if (dismissed || !textEl) return;
    i = (i + 1) % SHUFFLE_POOL.length;
    textEl.textContent = SHUFFLE_POOL[i];
  }, SHUFFLE_MS);

  // ── Lock to final text near the end
  const lockTimer = setTimeout(function () {
    clearInterval(shuffleTimer);
    if (textEl) textEl.textContent = FINAL_TEXT;
  }, SHUFFLE_END);

  // ── Dismiss at total duration
  const dismissTimer = setTimeout(dismiss, TOTAL_MS);
})();
